import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { Text } from '../../new-libby/core/typography';
export var FormControlKey = 'form-control'; // To major tom
var FormControl = /** @class */ (function (_super) {
    __extends(FormControl, _super);
    function FormControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormControl.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames(FormControlKey, props.className, !!props.validationError ? 'with-error' : '');
        var maybeErrorMsg = props.validationError ? React.createElement("div", { className: 'validation-error' }, props.validationError) : null;
        var comp = props.label ? (React.createElement("label", { className: 'form-control-wrapper' },
            React.createElement(Text, { color: 't30', className: 'label' }, props.label),
            props.children)) : (props.children);
        return (React.createElement("div", { className: classNames, "aria-label": props.ariaLabel },
            comp,
            maybeErrorMsg));
    };
    return FormControl;
}(React.PureComponent));
export { FormControl };
//# sourceMappingURL=index.js.map